<template>
  <div class="text-block">
    <div  :class="needShowMore && !showMore?'less':''">
      <div class="show">
        <div class="text">{{text}}</div>
      </div>
      <div v-if="needShowMore " class="more" @click="showMore = !showMore"><span>{{showMore?getDict(23):getDict(60)}}</span><i class="icon icon-circle-more"></i></div>
      <div style="clear: both"></div>
    </div>
    
    <div class="hidden" ref="testDiv">{{text}}</div>
  </div>
</template>

<script>
  import { getDict, axios} from '../../common'

  export default {
    props:{
      text:{}
    },
    data(){
      return {
        showMore:false,
        needShowMore:false,
      }
    },
    computed:{
    },
    watch:{
    },
    methods: {
      getDict,
      calcNeedShowMore(){
        if(this.$refs.testDiv){
          if(this.$refs.testDiv.scrollHeight > this.$refs.testDiv.clientHeight){
            this.needShowMore = true;
          }else{
            this.needShowMore = false;
          }
        }
      }
    },
    components: {
      alert,
    },
    mounted(){
      this.calcNeedShowMore();
    },
    created(){
    }
  }
</script>

<style lang="scss" scoped>
  .text-block{
    position: relative;
    overflow: hidden;
    // display: flex;
    // flex: 1;
    .hidden{
      position: absolute;
      width: 100%;
      bottom: 100%;


      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .less{
      .text{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .more .icon{
        transform: scaleY(1);
      }
    }

    .show,.more{
      display: inline
    }
    .more{
      float: right;
      color: #ffc44f;
      .icon{
        margin:0;
        margin-left: 0.05rem;
        vertical-align: bottom;
        transform: scaleY(-1);
      }
    }


    

    

    
   
  }

</style>
